<template>
  <div class="contest-detail-container">
    <!-- 顶部横幅 -->
    <TopHeader />

    <!-- 主内容 -->
    <div class="main-content">
      <div class="back-link" @click="goBack">
        <img src="@/assets/image/back.png" class="back-icon" />
        <span>{{ activity ? activity.title : '活动详情' }}</span>
      </div>

      <div class="content-card" v-if="activity">
        <h2 class="section-title">活动详情</h2>
        
        <div class="detail-content">
          <h3>{{ activity.title }}</h3>
          <div class="detail-meta">
            <span>{{ activity.typeName || '活动' }}</span>
            <span>{{ formatTime(activity.activityTime) }}</span>
            <span>{{ activity.viewCount || 0 }} 浏览</span>
          </div>
          
          <div class="divider"></div>
          
          <div v-html="processedContent"></div>
        </div>
      </div>

      <div class="content-card" v-else-if="loading">
        <div class="loading-text">加载中...</div>
      </div>

      <div class="content-card" v-else>
        <div class="loading-text">活动不存在</div>
      </div>

      <div class="back-top" @click="scrollToTop">
        <img src="@/assets/image/up.png" class="arrow-icon" />
        <span>顶部</span>
      </div>
    </div>
  </div>
</template>

<script>
import TopHeader from '@/components/TopHeader.vue'
import { getActivityDetail } from '@/api/activity'
import { decodeId } from '@/utils/idEncoder'
import config from '@/utils/config'

export default {
  name: 'ActivityDetail',
  components: {
    TopHeader
  },
  data() {
    return {
      activity: null,
      loading: true
    }
  },
  computed: {
    processedContent() {
      if (!this.activity || !this.activity.content) return ''
      // 处理图片路径，移除/dev-api前缀，将相对路径转为完整路径
      let content = this.activity.content
      // 先处理带/dev-api的路径
      content = content.replace(
        /src=["'](?:http[s]?:\/\/[^/]+)?\/dev-api(\/[^"']+)["']/g,
        `src="${config.imageBaseURL}$1"`
      )
      // 再处理普通相对路径
      content = content.replace(
        /src=["'](?!http)(\/[^"']+)["']/g,
        `src="${config.imageBaseURL}$1"`
      )
      return content
    }
  },
  created() {
    this.loadActivity()
  },
  methods: {
    async loadActivity() {
      const activityId = decodeId(this.$route.params.id)
      if (!activityId) {
        this.loading = false
        return
      }
      try {
        const res = await getActivityDetail(activityId)
        this.activity = res.data
      } catch (error) {
        console.error('加载失败', error)
      }
      this.loading = false
    },
    formatTime(time) {
      if (!time) return ''
      const d = new Date(time)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hour = String(d.getHours()).padStart(2, '0')
      const minute = String(d.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hour}:${minute}`
    },
    goBack() {
      this.$router.go(-1)
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
    }
  }
}
</script>

<style scoped>
.contest-detail-container {
  min-height: 100vh;
  background: #f5f5f5;
  padding-top: 70px;
}

.main-content {
  max-width: 1000px;
  margin: 0 auto;
  padding: 20px;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #333;
  font-size: 16px;
  margin-bottom: 20px;
  cursor: pointer;
  padding: 10px 0;
}

.back-icon {
  width: 16px;
  height: 16px;
}

.back-link:hover {
  color: #3d8c40;
}

.content-card {
  background: #fff;
  border-radius: 8px;
  padding: 30px;
}

.section-title {
  font-size: 16px;
  color: #333;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
  margin-bottom: 20px;
}

.detail-content h3 {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
}

.detail-meta {
  display: flex;
  gap: 20px;
  font-size: 13px;
  color: #999;
  margin-bottom: 0;
}

.detail-content p {
  font-size: 14px;
  color: #666;
  line-height: 2;
  margin: 0;
}

.divider {
  height: 1px;
  background: #eee;
  margin: 20px 0;
}

.detail-content :deep(img) {
  max-width: 100%;
  height: auto;
}

.loading-text {
  text-align: center;
  color: #999;
  padding: 40px 0;
}

.back-top {
  position: fixed;
  right: 30px;
  bottom: 30px;
  padding: 10px 15px;
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 4px;
}

.arrow-icon {
  width: 12px;
  height: 12px;
}

.back-top:hover {
  border-color: #3d8c40;
  color: #3d8c40;
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .main-content {
    padding: 15px;
  }

  .back-link {
    font-size: 14px;
  }

  .content-card {
    padding: 20px 15px;
  }

  .section-title {
    font-size: 15px;
  }

  .detail-content h3 {
    font-size: 15px;
  }

  .detail-meta {
    flex-wrap: wrap;
    gap: 10px;
  }

  .detail-content p {
    font-size: 13px;
    line-height: 1.8;
  }

  .back-top {
    right: 15px;
    bottom: 20px;
  }
}
</style>
